if(!customElements.get('product-recommendations')){
  customElements.define('product-recommendations',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.loaded==='true'||!this.dataset.url)return;
      this.dataset.loaded='true';
      fetch(this.dataset.url,{credentials:'same-origin'})
        .then(response=>{if(!response.ok)throw new Error('Recommendations unavailable');return response.text()})
        .then(html=>{
          const doc=new DOMParser().parseFromString(html,'text/html');
          const incoming=doc.querySelector('product-recommendations');
          if(incoming&&incoming.innerHTML.trim()){
            this.innerHTML=incoming.innerHTML;
            this.hidden=false;
          }else{this.remove();}
        })
        .catch(()=>this.remove());
    }
  });
}

document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('[data-cart-drawer]'), overlay=document.querySelector('[data-cart-overlay]');
  const open=()=>{drawer?.classList.add('is-open');overlay?.classList.add('is-open');document.body.classList.add('rc-no-scroll')};
  const close=()=>{drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');document.body.classList.remove('rc-no-scroll')};
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',open));
  document.querySelectorAll('[data-cart-close]').forEach(b=>b.addEventListener('click',close));
  overlay?.addEventListener('click',close);
  document.querySelector('.rc-mobile-toggle')?.addEventListener('click',e=>{
    const nav=document.getElementById('MobileNav'); const expanded=e.currentTarget.getAttribute('aria-expanded')==='true';
    e.currentTarget.setAttribute('aria-expanded',String(!expanded));
    e.currentTarget.setAttribute('aria-label',expanded?'Open menu':'Close menu');
    nav?.classList.toggle('is-open');
  });
  document.addEventListener('click',e=>{
    const nav=document.getElementById('MobileNav'), toggle=document.querySelector('.rc-mobile-toggle');
    if(nav?.classList.contains('is-open')&&!nav.contains(e.target)&&!toggle?.contains(e.target)){nav.classList.remove('is-open');toggle?.setAttribute('aria-expanded','false');toggle?.setAttribute('aria-label','Open menu');}
  });
  document.querySelectorAll('[data-mobile-add]').forEach(btn=>btn.addEventListener('click',()=>{
    const form=document.querySelector('[data-product-form]');
    const submit=form?.querySelector('.rc-add-btn');
    if(submit&&!submit.disabled) submit.click();
  }));
  const goToCheckout=async(btn)=>{
    const form=btn.closest('[data-product-form]') || document.querySelector('[data-product-form]');
    const variant=form?.querySelector('[name="id"]:checked')?.value || form?.querySelector('[name="id"]')?.value;
    const quantity=Math.max(1,parseInt(form?.querySelector('[name="quantity"]')?.value||'1',10));
    if(!variant){return;}
    const original=btn.textContent;
    btn.disabled=true;btn.textContent='Please wait…';
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity}]})});
      if(!response.ok)throw new Error('Could not add item');
      window.location.assign('/checkout');
    }catch(error){btn.disabled=false;btn.textContent='Try again';setTimeout(()=>{btn.textContent=original},1800);}
  };
  document.querySelectorAll('[data-buy-now]').forEach(btn=>btn.addEventListener('click',()=>goToCheckout(btn)));
  document.querySelectorAll('[data-mobile-buy]').forEach(btn=>btn.addEventListener('click',()=>goToCheckout(btn)));
  document.querySelectorAll('[data-qty-minus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(1,(parseInt(i.value)||1)-1)}));
  document.querySelectorAll('[data-qty-plus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=(parseInt(i.value)||1)+1}));
  const toast=(msg)=>{const t=document.getElementById('ReadCoveToast');if(t){t.textContent=msg;t.classList.add('is-visible');setTimeout(()=>t.classList.remove('is-visible'),2200)}};
  document.querySelectorAll('[data-quick-add]').forEach(btn=>btn.addEventListener('click',async()=>{
    if(btn.disabled)return;
    btn.disabled=true;
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(btn.dataset.quickAdd),quantity:1}]})});
      if(!r.ok) throw new Error();
      const cart=await fetch('/cart.js').then(x=>x.json());
      document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
      document.querySelectorAll('[data-cart-total]').forEach(x=>x.textContent=(cart.total_price/100).toLocaleString(undefined,{style:'currency',currency:cart.currency}));
      toast('Added to your cart'); open();
    }catch(e){toast('Please try again.');}finally{btn.disabled=false;}
  }));
  const wishlistKey='readcove_wishlist';
  const readWishlist=()=>{try{const value=JSON.parse(localStorage.getItem(wishlistKey)||'[]');return Array.isArray(value)?value.filter(item=>typeof item==='string'&&item.length):[]}catch(e){return []}};
  const paintWishlistButtons=()=>{
    const saved=readWishlist();
    document.querySelectorAll('[data-wishlist]').forEach(button=>{
      const isSaved=saved.includes(button.dataset.wishlist);
      button.textContent=isSaved?'♥':'♡';
      button.classList.toggle('is-wishlisted',isSaved);
      button.setAttribute('aria-pressed',String(isSaved));
      button.setAttribute('aria-label',isSaved?'Remove from wishlist':'Save to wishlist');
    });
  };
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-wishlist]');
    if(!button)return;
    e.preventDefault(); e.stopPropagation();
    const handle=button.dataset.wishlist;
    if(!handle)return;
    const saved=readWishlist();
    const next=saved.includes(handle)?saved.filter(item=>item!==handle):saved.concat(handle);
    try{localStorage.setItem(wishlistKey,JSON.stringify(next));}catch(err){toast('Wishlist unavailable in this browser.');return;}
    paintWishlistButtons();
    window.dispatchEvent(new CustomEvent('readcove:wishlist-updated',{detail:{handles:next}}));
    toast(next.includes(handle)?'Saved to wishlist':'Removed from wishlist');
  });
  window.addEventListener('storage',e=>{if(e.key===wishlistKey)paintWishlistButtons()});
  window.addEventListener('readcove:wishlist-updated',paintWishlistButtons);
  paintWishlistButtons();
});

/* Product quantity subtotal and cart shipping estimate */
document.addEventListener('DOMContentLoaded',()=>{
  const money=(cents,currency)=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100)}catch(e){return '$'+((Number(cents)||0)/100).toFixed(2)}};
  document.querySelectorAll('[data-product-pricing]').forEach(box=>{
    const form=document.querySelector('[data-product-form]'); if(!form)return;
    const qty=form.querySelector('[data-product-quantity]');
    const variant=form.querySelector('[data-variant-select]');
    const unit=box.querySelector('[data-unit-price]'); const compare=box.querySelector('[data-compare-price]'); const subtotal=box.querySelector('[data-product-subtotal]');
    const currency=box.dataset.currency||'USD';
    const refresh=()=>{let price=Number(variant?.selectedOptions?.[0]?.dataset.priceCents||unit?.dataset.priceCents||0);let comparePrice=Number(variant?.selectedOptions?.[0]?.dataset.compareCents||0);let count=Math.max(1,parseInt(qty?.value||'1',10)||1);if(qty)qty.value=count;if(unit){unit.dataset.priceCents=price;unit.textContent=money(price,currency)}if(compare){compare.dataset.priceCents=comparePrice;compare.hidden=!(comparePrice>price);compare.textContent=money(comparePrice,currency)}if(subtotal){subtotal.dataset.priceCents=price*count;subtotal.textContent=money(price*count,currency)}};
    qty?.addEventListener('input',refresh); qty?.addEventListener('change',refresh); variant?.addEventListener('change',refresh);
    form.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>requestAnimationFrame(refresh)));refresh();
  });
});
/* V1.6.7 mobile shelf arrows: delegated, supports sections loaded after initial render. */
document.addEventListener('click',function(event){
  var btn=event.target.closest('.rc-shelf-arrow'); if(!btn) return;
  var section=btn.closest('.rc-section'); if(!section) section=btn.closest('section'); if(!section) return;
  var shelf=section.querySelector('.rc-swipe-shelf'); if(!shelf) return;
  var card=shelf.querySelector('.rc-product-card, .rc-category-card');
  var step=card ? card.getBoundingClientRect().width + 12 : shelf.clientWidth * 0.8;
  shelf.scrollBy({left:(btn.classList.contains('rc-shelf-next')?step:-step),behavior:'smooth'});
});

/* V1.7.4 gallery: resilient initialization, scroll-by-viewport, touch swipe, mouse drag, arrows and dots. */
(function(){
 function initProductGalleries(){
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
   if(gallery.dataset.galleryReady==='true') return;
   var viewport=gallery.querySelector('[data-gallery-viewport]');
   var track=gallery.querySelector('[data-gallery-track]');
   var slides=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
   var dots=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
   var prev=gallery.querySelector('[data-gallery-prev]'), next=gallery.querySelector('[data-gallery-next]');
   if(!viewport||!track||slides.length<2) return;
   gallery.dataset.galleryReady='true';
   var active=0, dragging=false, startX=0, startScroll=0, moved=false;
   function goTo(index,behavior){
    active=Math.max(0,Math.min(slides.length-1,index));
    viewport.scrollTo({left:active*viewport.clientWidth,behavior:behavior||'smooth'});
    updateDots();
   }
   function updateDots(){dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===active);if(i===active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});}
   if(prev)prev.addEventListener('click',function(e){e.preventDefault();goTo(active-1)});
   if(next)next.addEventListener('click',function(e){e.preventDefault();goTo(active+1)});
   dots.forEach(function(dot){dot.addEventListener('click',function(e){e.preventDefault();goTo(parseInt(dot.getAttribute('data-gallery-dot'),10)||0)})});
   var scrollTimer;
   viewport.addEventListener('scroll',function(){window.clearTimeout(scrollTimer);scrollTimer=window.setTimeout(function(){active=Math.round(viewport.scrollLeft/Math.max(1,viewport.clientWidth));active=Math.max(0,Math.min(slides.length-1,active));updateDots()},40)},{passive:true});
   viewport.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();goTo(active+1)}else if(e.key==='ArrowLeft'){e.preventDefault();goTo(active-1)}});
   viewport.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')return;if(e.button!==0)return;dragging=true;moved=false;startX=e.clientX;startScroll=viewport.scrollLeft;viewport.style.cursor='grabbing';});
   window.addEventListener('pointermove',function(e){if(!dragging)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;if(moved)viewport.scrollLeft=startScroll-dx;});
   window.addEventListener('pointerup',function(e){if(!dragging)return;dragging=false;viewport.style.cursor='';if(moved){var dx=e.clientX-startX;goTo(active+(dx<-35?1:dx>35?-1:0));window.setTimeout(function(){moved=false},80)}});
   viewport.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
   window.addEventListener('resize',function(){goTo(active,'auto')});
   updateDots();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initProductGalleries);else initProductGalleries();
})();
